<template>
  <div class="text-center">
    <v-dialog
        v-model="loadingDialog"
        hide-overlay
        persistent
        width="300"
    >
      <v-card
          color="primary"
          dark
      >
        <v-card-text>
          <br/>
          Sedang di proses ...
          <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import Utils from "@/plugins/utils";
import moment from "moment";

export default {
  name: "LoadingDialog",
  data: ()=>({

  }),
  mounted() {
    console.log('OPEN MY MODAL')
  },
  computed: {
    ...mapState('Bayartempo',['loadingDialog'])
  },
  methods: {

    ...mapActions('Bayartempo',['toggleLoadingDialog']),
    formatAngka(val){
      return Utils.formatAngka(val)
    },
    formatDate (value) {
      return moment(value).add(7,'hours').format("YYYY/MM/DD HH:mm:ss")
    },

  }
}
</script>

<style scoped>

</style>